/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.33"
        height="95.62"
        viewBox="0 0 95.33 95.62"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M46.01 28.81v3.3l-.51.09-.51.11a7.84 7.84 0 0 0-6 4.83 9.73 9.73 0 0 0-.69 4.5 7.73 7.73 0 0 0 4.15 6.57 33.33 33.33 0 0 0 3.45 1.55c1.45.61 2.92 1.17 4.37 1.78a2.64 2.64 0 0 1 1.64 2.88 2.85 2.85 0 0 1-2.3 2.88 8.69 8.69 0 0 1-1.83.2 4.54 4.54 0 0 1-4.65-3.39c-.13-.4-.23-.82-.36-1.27l-5.47 1.47a11.53 11.53 0 0 0 2.67 5.46 9.31 9.31 0 0 0 6 2.78v4.27h3.57V62.6c.71-.14 1.41-.25 2.09-.43a8.25 8.25 0 0 0 5.82-4.71 9.66 9.66 0 0 0 .67-5.76 7.61 7.61 0 0 0-3.86-5.48 42.77 42.77 0 0 0-5.29-2.31c-1.08-.43-2.13-.93-3.18-1.44a2.32 2.32 0 0 1-1.18-1.44 3.22 3.22 0 0 1 2.13-4h.12a3.75 3.75 0 0 1 3.69 1 7 7 0 0 1 1.51 2.28c.12.27.23.54.35.83l5-2a9.94 9.94 0 0 0-1.82-3.72 8.71 8.71 0 0 0-6-3.13v-3.48Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M29.17 65.17a1.26 1.26 0 0 1 1.25 1.12v14.22a1.26 1.26 0 0 1-1.28 1.22 1.24 1.24 0 0 1-1.21-1.09v-13H14.86a1.23 1.23 0 0 1-1.24-1.13v-.13a1.23 1.23 0 0 1 1.12-1.24h14.48Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M28.23 65.59a1.24 1.24 0 0 1 1.76-.07 1.25 1.25 0 0 1 .1 1.74l-.09.1L2.13 95.23a1.26 1.26 0 0 1-1.77-.05 1.25 1.25 0 0 1-.08-1.62l.09-.1ZM29.17 13.57a1.26 1.26 0 0 1 1.25 1.12v14.49a1.27 1.27 0 0 1-1.12 1.25H15.08a1.27 1.27 0 0 1-1.23-1.28 1.25 1.25 0 0 1 1.1-1.21h13V14.82a1.24 1.24 0 0 1 1.13-1.24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M.37.38a1.23 1.23 0 0 1 1.66-.1l.1.1 27.88 27.87a1.24 1.24 0 0 1 0 1.76 1.28 1.28 0 0 1-1.67.09l-.1-.09L.37 2.13a1.25 1.25 0 0 1 0-1.76ZM80.5 65.17a1.24 1.24 0 0 1 1.22 1.27 1.26 1.26 0 0 1-1.09 1.22h-13.2v12.85a1.27 1.27 0 0 1-1.12 1.25h-.13a1.25 1.25 0 0 1-1.24-1.12V66.42a1.23 1.23 0 0 1 1.12-1.24H80.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M65.3 65.51a1.22 1.22 0 0 1 1.67 0l.1.09 27.91 27.91a1.25 1.25 0 0 1 0 1.76 1.26 1.26 0 0 1-1.63.1l-.1-.09-27.92-28a1.25 1.25 0 0 1-.05-1.76ZM66.18 13.57a1.25 1.25 0 0 1 1.24 1.12v13.24h12.84a1.23 1.23 0 0 1 1.24 1.12v.13a1.27 1.27 0 0 1-1.12 1.25h-14.2a1.27 1.27 0 0 1-1.25-1.12V14.82a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M93.22.38a1.24 1.24 0 0 1 1.76 0 1.26 1.26 0 0 1 .1 1.63l-.1.1-27.9 27.91a1.26 1.26 0 0 1-1.77 0 1.26 1.26 0 0 1-.09-1.67l.09-.1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DollarSignWithFourArrowsPointingInwardIcon';

export default Icon;
